import { render, staticRenderFns } from "./CurrentStaticsFilter.vue?vue&type=template&id=64993595&"
import script from "./CurrentStaticsFilter.vue?vue&type=script&lang=js&"
export * from "./CurrentStaticsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports